import { DISCOUNT_TYPE, TSelectedSkuItem } from "@elixir/types";
import { TReceiptSku } from "../../../types/appointment";
import { TReceiptEntity } from "../../../types/billing";
import ServicesAutosuggest from "../../common/services-autosuggest";
import BillingServiceSearchInput from "./billing-service-search-input";
import BillingServiceSearchPopup from "./billing-service-search-popup";

const BillingServiceAutosuggest = ({
  receiptEntity,
  isDisabled,
  onServiceSelection,
}: {
  receiptEntity: TReceiptEntity;
  isDisabled?: boolean;
  onServiceSelection: (receipt: TReceiptEntity) => void;
}) => {
  const handleServiceSelection = ({
    service,
  }: {
    service: TSelectedSkuItem;
  }) => {
    const { paymentItems, receiptSkus } = receiptEntity;
    const currPaymentItem = paymentItems[0];
    const currReceiptSku = receiptSkus[0];

    const { price, service_id, service_name } = service;

    const newSkuItem: TReceiptSku = {
      amount: price === undefined ? currReceiptSku?.net_amount : price,
      discount_amount: 0,
      discount_type: DISCOUNT_TYPE.AMOUNT,
      discount_value: 0,
      net_amount: price === undefined ? currReceiptSku?.net_amount : price,
      quantity: 1,
      sku_item: {
        price: price === undefined ? currReceiptSku?.net_amount : price,
        service_id: service_id as number,
        service_name,
        archive: false,
      },
    };

    onServiceSelection({
      ...receiptEntity,
      receiptSkus: [newSkuItem],
      paymentItems: [
        {
          amount: price === undefined ? currReceiptSku?.net_amount : price,
          paymode: currPaymentItem?.paymode || "CASH",
        },
      ],
    });
  };

  const { receiptSkus } = receiptEntity;
  const currService = receiptSkus[0]?.sku_item;

  const multipleServiceNames =
    receiptSkus.length > 1
      ? receiptSkus?.map((sku) => sku.sku_item.service_name).join(", ")
      : "";

  const handleServiceInputValueChange = (newInputValue: string) => {
    if (newInputValue !== currService?.service_name) {
      const { receiptSkus } = receiptEntity;
      const currReceiptSku = receiptSkus[0];
      if (!currReceiptSku) {
        const newSkuItem: TReceiptSku = {
          sku_item: {
            service_id: null,
            service_name: newInputValue,
            price: 0,
          },
          amount: 0,
          discount_amount: 0,
          discount_type: "AMOUNT",
          discount_value: 0,
          net_amount: 0,
          quantity: 1,
        };

        onServiceSelection({
          ...receiptEntity,
          receiptSkus: [newSkuItem],
        });
        return;
      }
      const { sku_item: currSkuItem } = currReceiptSku || {};

      const newSkuItem: TReceiptSku = {
        ...currReceiptSku,
        sku_item: {
          ...currSkuItem,
          service_id: null,
          service_name: newInputValue,
        },
      };

      onServiceSelection({
        ...receiptEntity,
        receiptSkus: [newSkuItem],
      });
    }
  };

  return (
    <ServicesAutosuggest
      isDisabled={isDisabled}
      currService={currService}
      onServiceValueInputChange={handleServiceInputValueChange}
      multipleServiceNames={multipleServiceNames}
      onServiceSelection={handleServiceSelection}
      SearchInputComponent={BillingServiceSearchInput}
      SearchPopupComponent={BillingServiceSearchPopup}
      inputPlaceholder={
        receiptEntity.receipt_type === "DUE_PAYMENT" ? "Due Payment" : undefined
      }
    />
  );
};

export default BillingServiceAutosuggest;
